import React from "react";
import { DashboardLoader } from "../../../../../components/Common/CommonButton";

/** KPI Card — animated, chevron on hover */
const KpiCard = ({ item, loading, onNav }) => (
  <div
    className={`sad-kpi-card${!item.path ? " sad-kpi-card--static" : ""}`}
    style={{ borderLeft: `4px solid ${item.color}` }}
    onClick={onNav}
    role={item.path ? "button" : undefined}
    tabIndex={item.path ? 0 : undefined}
    onKeyDown={(e) => e.key === "Enter" && onNav()}
  >
    <div className="sad-kpi-icon" style={{ background: `${item.color}18`, color: item.color }}>
      <i className={item.icon} />
    </div>
    <div className="sad-kpi-body">
      <div className="sad-kpi-label">{item.title}</div>
      <div
        className="sad-kpi-value"
        style={{ fontSize: typeof item.value === "string" ? "16px" : undefined }}
      >
        {loading ? <DashboardLoader /> : item.value}
      </div>
      {item.sub && !loading && <div className="sad-kpi-sub">{item.sub}</div>}
    </div>
    {item.path && <i className="bx bx-chevron-right sad-kpi-chevron" />}
  </div>
);

export default KpiCard;
